export default __webpack_public_path__ + "static/media/page-logo.d702ad1a.svg";